// extracted by mini-css-extract-plugin
export var item = "IconList-module--item--aZ6Q1";
export var root = "IconList-module--root--zc6Us";